"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const context_1 = require("./context");
const react_hooks_1 = require("@apollo/react-hooks");
const graphql_1 = require("../../graphql");
exports.useContentImportPanelData = () => {
    return react_1.useContext(context_1.ContentImportPanelDataContext);
};
exports.useContentImportPanelUpdate = () => {
    return react_1.useContext(context_1.ContentImportPanelUpdateContext);
};
exports.useContentItems = (contentFeed) => {
    const result = react_hooks_1.useQuery(graphql_1.contentItems, {
        fetchPolicy: 'cache-and-network',
        // notifyOnNetworkStatusChange: true,
        skip: !(contentFeed && contentFeed.id),
        variables: {
            contentFeedId: contentFeed && contentFeed.id,
        },
    });
    return result;
};
//# sourceMappingURL=hooks.js.map